import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  return <section className="py-20 bg-slate-50 px-4" data-id="element-305">
      <div className="max-w-6xl mx-auto" data-id="element-306">
        <div className="text-center mb-12" data-id="element-307">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-308">
            Lo que dicen quienes ya lo aplicaron
          </h2>
          <p className="text-lg text-slate-600" data-id="element-309">
            Resultados reales de emprendedores argentinos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-310">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-311">
            <div className="flex gap-1 mb-4" data-id="element-312">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-313" />)}
            </div>
            <p className="text-slate-700 text-lg mb-6 italic" data-id="element-314">
              "Logré que los ingresos de mi tienda aumentaran este último mes
              gracias a una mejor publicidad, después de haber tenido un período
              de malas ventas. Finalmente entendí qué estaba haciendo mal y cómo
              corregirlo."
            </p>
            <div className="flex items-center gap-4" data-id="element-315">
              <div className="w-12 h-12 bg-sky/20 rounded-full flex items-center justify-center text-navy font-bold text-xl" data-id="element-316">
                M
              </div>
              <div data-id="element-317">
                <p className="font-bold text-navy" data-id="element-318">Mario F.</p>
                <p className="text-sm text-slate-500" data-id="element-319">
                  Dueño de tienda online · Buenos Aires
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-320">
            <div className="flex gap-1 mb-4" data-id="element-321">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-322" />)}
            </div>
            <p className="text-slate-700 text-lg mb-6 italic" data-id="element-323">
              "Mis últimas campañas dieron muy buenos resultados con ayuda de
              este producto. Cada vez hay más visitas y lo mejor es que el
              contenido que publico ahora tiene una dirección clara, no es más
              publicar por publicar."
            </p>
            <div className="flex items-center gap-4" data-id="element-324">
              <div className="w-12 h-12 bg-sky/20 rounded-full flex items-center justify-center text-navy font-bold text-xl" data-id="element-325">
                A
              </div>
              <div data-id="element-326">
                <p className="font-bold text-navy" data-id="element-327">Alejandra R.</p>
                <p className="text-sm text-slate-500" data-id="element-328">
                  Emprendedora · Argentina
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}